import gql from 'graphql-tag';

export default gql`
  mutation adminEditSchoolContacts($input: AdminEditSchoolContactsInput!) {
    adminEditSchoolContacts(input: $input) {
      id
    }
  }
`;
